import React, { Component, ReactElement } from 'react'
import { CommonFormContextProvider } from '../../React/Common/Contexts/CommonFormContext'
import { UserInfoContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { MFALoginAndSetup } from '../Components/Organisms/MFALogin/Main/MFALoginAndSetup'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { RouteGuard } from '../Guards/RouteGuard'

@Route(RouteID.MFA)
export class MFA extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.MFA}>
                <UserInfoContextProvider>
                    <CommonFormContextProvider>
                        <WelcomeContainer>
                            <div className='router-multi-factor-authentication'>
                                <MFALoginAndSetup />
                            </div>
                        </WelcomeContainer>
                    </CommonFormContextProvider>
                </UserInfoContextProvider>
            </RouteGuard>
        )
    }
}
